import React from "react";

export default ({ className }) => <svg className={className} height="600pt" viewBox="-19 -19 600 600" width="600pt">
  <path fill="currentColor" d="m251.25 12.5c0-6.90625-5.59375-12.5-12.5-12.5h-226.25c-6.90625 0-12.5 5.59375-12.5 
  12.5v226.25c0 6.90625 5.59375 12.5 12.5 12.5h226.25c6.90625 0 12.5-5.59375 12.5-12.5zm-25 
  213.75h-201.25v-201.25h201.25zm0 0"/>
  <path fill="currentColor" d="m562.5 12.5c0-6.90625-5.59375-12.5-12.5-12.5h-226.25c-6.90625 0-12.5 5.59375-12.5 
  12.5v226.25c0 6.90625 5.59375 12.5 12.5 12.5h226.25c6.90625 0 12.5-5.59375 12.5-12.5zm-25 
  213.75h-201.25v-201.25h201.25zm0 0"/>
  <path fill="currentColor" d="m251.25 323.75c0-6.90625-5.59375-12.5-12.5-12.5h-226.25c-6.90625 0-12.5 5.59375-12.5 
  12.5v226.25c0 6.90625 5.59375 12.5 12.5 12.5h226.25c6.90625 0 12.5-5.59375 12.5-12.5zm-25 
  212.5h-201.25v-200h201.25zm0 0"/>
  <path fill="currentColor" d="m562.5 323.75c0-6.90625-5.59375-12.5-12.5-12.5h-226.25c-6.90625 0-12.5 5.59375-12.5 
  12.5v226.25c0 6.90625 5.59375 12.5 12.5 12.5h226.25c6.90625 0 12.5-5.59375 12.5-12.5zm-25 
  212.5h-201.25v-200h201.25zm0 0"/>
</svg>